
import * as angular from "angular";
import {LogService} from "./log.service";


export const LogModule = angular
    .module("app.shared.log", [])
    .service("logService", LogService)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/log/log.module.ts